module.exports = __webpack_public_path__ + "static/media/12-08-react-router-basic-starter.26601225.md";